import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable, catchError, finalize, map } from "rxjs";
import { Logger } from "./services/logger/logger.service";
import { LoginService } from "./services/login/login.service";
import { UtilService } from "./services/util/util.service";
import { Injectable } from "@angular/core";

const logger = new Logger("HttpInterceptor");

const ACCESS_DENIED_403_TEXT =
  "You don't have a valid role to access that page.";
const FORBIDDEN_401_TEXT =
  "Error with authentication. Please try logging in again.";

@Injectable({
  providedIn: "root",
})
export class HttpRequestInterceptor implements HttpInterceptor {
  ignoreAPIs = ["getConfig", "token", "app-info"];
  serviceCheckAPIs = ["getConfig", "token", "getUser", "app-info"];
  isRunningReloginApi: boolean = false;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private utilService: UtilService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add auth header with jwt if account is logged in and request is to the api url
    const isLoggedIn = localStorage.getItem("token");
    const isRefreshToken = localStorage.getItem('refreshToken');
    const isApiUrl = request.url.indexOf('/login') < 0 ||
    request.url.indexOf('/reset-password') < 0 ||
    request.url.indexOf('/forgot-password') < 0;
    const isDownloadApi = request.url.indexOf('/download') > -1;
    const isRefreshTokenUrl = request.url.indexOf('/refresh-token') > -1 ;
    const isMultipartHeader = (request.url.indexOf('brand/product') > -1 || request.url.indexOf('brand/detail') > -1) && request.method == 'POST';
    const isGoogleMap = request.url.indexOf('https://maps.googleapis.com/') > -1;
     if((isDownloadApi || isMultipartHeader) && isLoggedIn && !isRefreshTokenUrl && !isGoogleMap) {
      request = request.clone({
        setHeaders: { 'Authorization': `Bearer ${isLoggedIn}`}
    });
    } else
     if (isLoggedIn && isApiUrl  &&!isRefreshTokenUrl && !isDownloadApi && !isGoogleMap) {
        request = request.clone({
            setHeaders: { 'Authorization': `Bearer ${isLoggedIn}`, 'Accept': 'application/json'}
        });
    } else if(isRefreshTokenUrl && isRefreshToken && !isDownloadApi && !isGoogleMap) {

      request = request.clone({
        setHeaders: { 'Authorization': `Bearer ${isRefreshToken}`, 'Accept': 'application/json'}
    });
    }else {
      if(!isGoogleMap){
        request = request.clone({
          setHeaders: {'Accept': 'application/json'}
      });
      }

    }

    return next
      .handle(request)
      .pipe(
        map((event: HttpEvent<any>) => {

          if (event instanceof HttpResponse) {
            if (event.status == 422 || event.status == 500) {
              logger.error("Error: 422 or 500");
            } else if (event.status === 401) {
              logger.error("Access denied for URL: " + request.url);
              if(!isRefreshTokenUrl && !this.isRunningReloginApi) {
                this.reLogin();
              }

            }
          }
          return event;
        }),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 403) {
            if(!error.error.message){
              error.error.message = ACCESS_DENIED_403_TEXT;
            }

          } else if (error.status === 401) {
            error.error.message = FORBIDDEN_401_TEXT;
          }
          throw error;
        }),
        finalize(() => {
          logger.info("finalized")
        })
      )
      .pipe(
        catchError(async (error: HttpErrorResponse) => {
          if (error.status === 403) {
           this.router.navigateByUrl("/app/access-denied");
          } else if (error.status === 401) {
            logger.error("Access denied for URL: " + request.url);
            if(!isRefreshTokenUrl && !this.isRunningReloginApi) {
              this.reLogin();
            }
          } else if (
            error.status == 0 ||
            error.status == 503 ||
            error.status == 502 ||
            (error.status == 404 &&
              this.serviceCheckAPIs.some((url) => request.url.includes(url)))
          ) {
            logger.error('Service Unavailable');
          }
          throw error;
        }),
        finalize(() => {
           logger.info("in interceptor finalize")
          })
      );
}

private reLogin() : void {

  const isRefreshToken = localStorage.getItem('refreshToken');
  this.isRunningReloginApi = true;
  if(isRefreshToken) {
    this.utilService.spinnerShow();
    const url = this.router.url === '/'? '/app/dashboard' : this.router.url ;
    this.loginService.refreshToken().subscribe({next: (res) =>{
      this.utilService.spinnerHide();
      if(res.token) {
        localStorage.setItem("token", res.token);
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          this.router.navigate([url]);
      });
      }
      this.isRunningReloginApi = false;
    }, error:  (err : HttpErrorResponse) =>{
      logger.error(err);
      this.isRunningReloginApi = false;
      this.utilService.spinnerHide();
      if(err.status === 401) {
        localStorage.clear();
        this.router.navigateByUrl('/login');
        this.utilService.spinnerCountZero();
      }
    }});
  } else{
    this.isRunningReloginApi = false;
    localStorage.clear();
    this.router.navigateByUrl('/login');
    this.utilService.spinnerCountZero();
  }
}
}
